import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningPlanGoalInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningPlanGoalApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'LearningPlanGoals');
  }

  filtered(
    searchTerm?: string,
    filters?: { [key: string]: string | number | number[] },
    pagination?: { from?; amount? },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: LearningPlanGoalInterface[]; count: number }> {
    const httpParams = this._getHttpParams({
      searchTerm: searchTerm || '',
      filters: filters || {},
      columns: columns || [],
      sorting: sorting || {},
      pagination: pagination || {},
    });
    return this.get<{ results: LearningPlanGoalInterface[]; count: number }>('filtered', httpParams);
  }
}
